import React from "react";

import "./style.scss";
import CheckoutView from "../gears-checkout-view";
import InStoreCheckoutView from "../gears-instore-checkout-view";
import { staffInfoSelector } from "../../selectors/application";
import { useSelector } from "react-redux";

const CheckoutDelivery = props => {
  /*Redux start*/
  const staffInfo = useSelector(staffInfoSelector);
  /*Redux end*/
  if (staffInfo) {
    return <InStoreCheckoutView {...props} />;
  } else {
    return <CheckoutView {...props} />;
  }
};
export default CheckoutDelivery;
